let $sliders = $('.anons-js');

window.addEventListener('resize', () => {
  $sliders.each((key, slider) => {
    initSlider($(slider));
  });
});
initSliders();

function initSliders() {
  $sliders.each((key, slider) => {
    initSlider($(slider));
    // let $slider = $(slider);

    //store all slides HTML without filter by language
    // let slides = [];
    // $slider.find('.anons-grid__item').each((key, slide) => {
    //   slides.push({
    //     html: slide.outerHTML,
    //     languages: slide.getAttribute('data-languages')
    //                   .split(',')
    //                   .map(a => parseInt(a)),
    //   });
    // });

    // initSliderLanguage($slider, slides);

    // let $languagesItems = $slider.closest('.section').find('.tab');
    // $languagesItems.click(function() {
    //   $slider.animate({opacity: 0}, 600);
    //   $languagesItems.removeClass('active');
    //   $(this).addClass('active');
    //
    //   setTimeout(function() {
    //     $slider.animate({opacity: 1}, 600);
    //     initSliderLanguage($slider, slides);
    //   }, 600);
    // });
  });
}

// function getCurrentLanguage($slider) {
//   return parseInt($slider.closest('.section')
//           .find('.tab.active')
//           .data('id'));
// }

// function initSliderLanguage($slider, slides) {
//   let currentLanguage = getCurrentLanguage($slider);
//   $slider.trigger('destroy.owl.carousel');
//
//   $slider.html('');
//   slides.forEach(slide => {
//     if(slide.languages.includes(currentLanguage)){
//       $slider.append(slide.html);
//     }
//   });
//
//   initSlider($slider);
// }

function initSlider($slider) {
  if(window.innerWidth > 560){
    $slider.trigger('destroy.owl.carousel');
  }else {
    $slider.owlCarousel({
      margin: 15,
      items: 1.1,
      center: true,
      dots: false,
    });
  }
}